import React from 'react';

export default ({ children, click, active, ...props }) => {
    return (
        <div
            onClick={click}
            className={`svg-bg${active ? ' svg-active' : ''}`}
            {...props}
        >
            {children}
        </div>
    )
}